import React, { useEffect, useState } from 'react';
import { Modal, Table, Button, Pagination } from 'react-bootstrap';
import APIserver from '../../../../api/axiosConfig';

function VerProductoModal({ show, handleClose, productoId }) {
  const [historial, setHistorial] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(5);

  useEffect(() => {
    if (productoId && show) {
      fetchHistorialProducto(productoId);
    }
  }, [productoId, show]);

  const fetchHistorialProducto = async (id) => {
    try {
      const response = await APIserver.get(`/api/productos/historial/${id}`);
      if (Array.isArray(response.data)) {
        setHistorial(response.data);
      } else if (response.data && Array.isArray(response.data.historial)) {
        setHistorial(response.data.historial);
      } else {
        setHistorial([]);
      }
    } catch (error) {
      console.error("Error al obtener el historial del producto:", error);
      setHistorial([]);
    }
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = historial.slice(indexOfFirstItem, indexOfLastItem);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const renderPagination = () => {
    const totalPages = Math.ceil(historial.length / itemsPerPage);
    if (totalPages <= 1) return null;

    const items = [];
    for (let number = 1; number <= totalPages; number++) {
      items.push(
        <Pagination.Item
          key={number}
          active={number === currentPage}
          onClick={() => handlePageChange(number)}
        >
          {number}
        </Pagination.Item>
      );
    }

    return <Pagination>{items}</Pagination>;
  };

  return (
    <Modal size="lg" show={show} onHide={handleClose} aria-labelledby="modal-ver-producto">
      <Modal.Header closeButton>
        <Modal.Title>Historial de Cambios del Producto</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>Campo Modificado</th>
              <th>Valor Anterior</th>
              <th>Valor Nuevo</th>
              <th>Valor Ingresado</th>
              <th>Fecha de Modificación</th>
            </tr>
          </thead>
          <tbody>
            {currentItems && currentItems.length > 0 ? (
              currentItems.map((entry, index) => (
                <tr key={index}>
                  <td>{entry.campoModificado}</td>
                  <td>{entry.valorAnterior}</td>
                  <td>{entry.valorNuevo}</td>
                  <td>{entry.valorNuevo - entry.valorAnterior}</td>
                  <td>{new Date(entry.fechaModificacion).toLocaleString()}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="text-center">No hay historial disponible</td>
              </tr>
            )}
          </tbody>
        </Table>
        {renderPagination()}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="dark" onClick={handleClose}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default VerProductoModal;
